import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useLayoutEffect, useMemo } from 'react';
import { areRenderPropsValueEqual } from '../_pure/valueEquality.js';
import { createConnectorRippleResources, updateConnectorRippleResources } from '../connectorRipple.js';
export const RippleConnectorLine = memo(function RippleConnectorLine(props) {
    const intervalCount = props.intervals?.length ?? 1;
    const resources = useMemo(() => createConnectorRippleResources(intervalCount), [intervalCount]);
    useLayoutEffect(() => {
        updateConnectorRippleResources(resources, { ...props, depthTest: props.depthTest ?? true });
    }, [resources, props]);
    useEffect(() => () => resources.dispose(), [resources]);
    return _jsx("lineSegments", { geometry: resources.geometry, material: resources.material, frustumCulled: false, dispose: null });
}, areRenderPropsValueEqual);
